import { useState, useEffect, useCallback, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Moment from "moment";
import Attachment from "./Attachment";
import Comment from "./Comment";
import ViewComment from "./VIewComment";
import AuthContext from "../../../auth/AuthContext";
import SupportService from "../../../services/SupportService";

const View = ({ ticket, clearSelection }) => {
  const [comments, setComments] = useState([]);
  const authContext = useContext(AuthContext);

const loadComments = useCallback(async (signal) => { 
    if (ticket) {
      try {
        const data = await SupportService.GetComments(
          ticket.id,
          authContext,
          signal
        );

        if (signal?.aborted) return; 

        if (data.isSuccess) {
          setComments(data.data);
        }
      } catch (err) {
        if (err.name === "AbortError") return; 
      }
    }
  }, [ticket, authContext]);

  useEffect(() => {
    const controller = new AbortController();
    loadComments(controller.signal); 
    return () => controller.abort();
  }, [loadComments]);

  const onCommentSaveHandler = async () => { await loadComments(); };

  return (
    <Container fluid className="mb-5 mt-3">
      {/* Ticket# and Back button */}
      <Row className="mb-3">
        <Col xs={6}>
          <div className="mb-1 support-label ">Ticket</div>
          <div>{ticket.ticketId}</div>
        </Col>
        <Col xs={6}>
          <div className="mb-1 support-label ">Status</div>
          <div>
            {ticket.statusDesc}
            {ticket.status === 3 && ticket.closedDate && (
              <>, Date: {Moment(ticket.closedDate).format("DD/MM/YYYY hh:mm A")}</>
            )}
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={6}>
          <div className="mb-1 support-label ">Category</div>
          <div>{ticket.categoryDesc}</div>
        </Col>
        <Col xs={6}>
          <div className="mb-1 support-label ">Course Name</div>
          <div>{ticket.courseName}</div>
        </Col>
      </Row>

      {/* Subject */}
      <Row className="mb-3">
        <Col xs={12}>
          <div className="mb-1 support-label ">Subject</div>
          <div>{ticket.subject}</div>
        </Col>
      </Row>

      {/* Description */}
      <Row className="mb-3">
        <Col xs={12}>
          <div className="mb-1 support-label ">Description</div>
          <div style={{ fontSize: "0.95rem", whiteSpace: "pre-line" }}>{ticket.description}</div>
        </Col>
      </Row>

      {/* Attachments */}
      <Row className="mb-3">
        <Col xs={12}>
          <div className="mb-1 support-label ">Attachments</div>
          <div className="d-flex flex-wrap gap-3">
            {ticket.attachments && ticket.attachments.length > 0 ? ticket.attachments?.map((att, i) => (
              <Attachment key={i} no={i + 1} attachment={att} />
            )) : ('No Attachments')}
          </div>
        </Col>
      </Row>
      {comments.length > 0 && (
        <Row className="mb-3">
          <Col xs={12}>
            <div className="mb-1 support-label ">Comments</div>
            {comments.map((com, i) => (
              <ViewComment key={i} comment={com} />
            ))}
          </Col>
        </Row>
      )}
      <Row>
        <Col xs={12}>
          <Comment ticketId={ticket.id} submitHandler={onCommentSaveHandler} cancelHandler={clearSelection} />
        </Col>
      </Row>
    </Container>
  );
};

export default View;
